<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Petty Cash",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Petty Cash",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Petty Cash",
          active: true,
        },
      ],
      data: {
        name: "",
        quantity: "",
        amount: "",
        narration: "",
      },
      itemList: [],
    };
  },
  computed: {
    ...mapGetters("pettycash", [
      "getPettyRequests",
      "SaveStatus",
      "getSuccessConfirm",
    ]),
    ...mapGetters("auth", ["getCurrentUser"]),
  },
  watch: {
    getSuccessConfirm(newValue) {
      if (newValue == true) {
        //clear list
        this.itemList = [];

        //reset  success confirmation
        this.ResetSuccessConfirm();
      }
    },
  },
  methods: {
    ...mapActions({
      SubmitPettyRequest: "pettycash/submitPettyRequest",
      ResetSuccessConfirm: "pettycash/resetSuccessConfirm",
      FetchPettyRequests: "pettycash/fetchPettyRequests",
    }),
    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    calculateSum(items) {
      return items.reduce((accumulator, object) => {
        return accumulator + object.quantity * object.amount;
      }, 0);
    },

    addCommas() {
      this.data.amount = this.thousandSeperater(this.data.amount);
    },
    addPettyItem() {
      this.itemList.push({
        id: Math.floor(Date.now() / 1000),
        name: this.data.name,
        quantity: this.data.quantity,
        amount: this.data.amount,
        narration: this.data.narration,
      });
      //reset inputs
      this.data = {
        name: "",
        quantity: "",
        amount: "",
        narration: "",
      };
    },
    clearItem(id) {
      this.itemList = this.itemList.filter((item) => item.id != id);
    },

    submitRequest() {
      this.SubmitPettyRequest({ items: this.itemList });
    },
  },
  created() {
    this.FetchPettyRequests();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('setting_sms')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="card-body row">
              <div class="col-md-4">
                <form @submit.prevent="addPettyItem">
                  <div class="row">
                    <div class="form-group col-md-12 mb-2">
                      <label
                        >Item Name <small class="text-danger">*</small></label
                      >
                      <div class="input-group">
                        <input
                          type="text"
                          required
                          class="form-control"
                          v-model="data.name"
                        />
                      </div>
                    </div>
                    <div class="form-group col-md-12 mb-2">
                      <label>Amount <small class="text-danger">*</small></label>
                      <div class="input-group">
                        <input
                          type="number"
                          required
                          class="form-control"
                          v-model="data.amount"
                        />
                      </div>
                    </div>
                    <div class="form-group col-md-12 mb-2">
                      <label
                        >Quntity <small class="text-danger">*</small></label
                      >
                      <div class="input-group">
                        <input
                          type="number"
                          required
                          class="form-control"
                          v-model="data.quantity"
                        />
                      </div>
                      <label
                        v-if="data.quantity != '' && data.amount != ''"
                        class="mt-2 text-muted"
                        ><b
                          >Total Amount:
                          {{
                            thousandSeperater(data.quantity * data.amount)
                          }}</b
                        ></label
                      >
                    </div>
                    <div class="form-group col-md-12 mb-2">
                      <label
                        >Description <small class="text-danger">*</small>
                        <span class="text-primary">
                          (Reason for the petty cash.)
                        </span></label
                      >
                      <textarea
                        v-model="data.narration"
                        class="form-control"
                        rows="3"
                        required
                        placeholder="Enter Reason for the request"
                      ></textarea>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      v-if="SaveStatus"
                      disabled
                      type="button"
                      class="btn btn-sm btn-outline-primary"
                    >
                      <b-spinner
                        variant="priamry"
                        small
                        label="Spinning"
                      ></b-spinner>
                      Adding...
                    </button>
                    <button
                      v-else
                      type="submit"
                      class="btn btn-sm btn-outline-primary"
                    >
                      <i class="fa fa-check"></i>
                      Add Item
                    </button>
                  </div>
                </form>
              </div>
              <div class="col-md-8">
                <b-tabs content-class="p-3 text-muted">
                  <b-tab active class="border-0">
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="fas fa-home"></i>
                      </span>
                      <span class="d-none d-sm-inline-block"
                        ><i class="fa fa-cube" aria-hidden="true"></i> Petty
                        Items</span
                      >
                    </template>
                    <div class="row mt-1">
                      <div class="col-12">
                        <strong class="card-title-desc">Added Items </strong>
                        <table class="table mt-2">
                          <thead>
                            <tr>
                              <th scope="col">Action</th>
                              <th scope="col">Name</th>
                              <th scope="col">Amount</th>
                              <th scope="col">Quantity</th>
                              <th scope="col">Total</th>
                              <th scope="col">Narration</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item, index) in itemList" :key="index">
                              <th scope="row">
                                <button
                                  class="btn btn-sm btn-danger"
                                  @click="clearItem(item.id)"
                                >
                                  <i
                                    class="fa fa-times-circle"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              </th>
                              <td>{{ item.name }}</td>
                              <td>{{ item.amount }}</td>
                              <td>{{ item.quantity }}</td>
                              <td>
                                {{
                                  thousandSeperater(item.amount * item.quantity)
                                }}
                              </td>
                              <td>
                                <p>{{ item.narration }}</p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="modal-footer mt-2" v-if="itemList.length > 0">
                        <button
                          v-if="SaveStatus"
                          disabled
                          type="button"
                          class="btn btn-sm btn-outline-primary"
                        >
                          <b-spinner
                            variant="priamry"
                            small
                            label="Spinning"
                          ></b-spinner>
                          Submitting...
                        </button>
                        <button
                          v-else
                          type="button"
                          @click="submitRequest()"
                          class="btn btn-sm btn-outline-success float-right"
                        >
                          <i class="fa fa-check"></i>
                          Submit Request
                        </button>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="far fa-user"></i>
                      </span>
                      <span class="d-none d-sm-inline-block"
                        ><i class="fa fa-list" aria-hidden="true"></i> Petty
                        Cash Requests</span
                      >
                    </template>
                    <div class="row col-md-12">
                      <strong class="card-title-desc">Recent Requests</strong>
                      <div role="tablist">
                        <b-card
                          no-body
                          class="mb-1 shadow-none"
                          v-for="(pettyCash, index) in getPettyRequests"
                          :key="index"
                        >
                          <b-card-header header-tag="header" role="tab">
                            <h6 class="m-0">
                              <div
                                v-b-toggle="'accordion-' + index"
                                class="text-dark"
                                href="javascript: void(0);"
                              >
                                Requested By: <b>{{ pettyCash.user.name }}</b> |
                                Amount:
                                <b>{{ calculateSum(pettyCash.petty_items) }}</b>
                                | Date:
                                <b>{{ pettyCash.request_date }}</b>

                                <strong
                                  v-if="pettyCash.status == 1"
                                  class="text-primary float-end"
                                  >Pending</strong
                                ><strong
                                  v-else-if="pettyCash.status == 2"
                                  class="text-success float-end"
                                  >Apprved</strong
                                >
                                <strong
                                  v-else-if="pettyCash.status == 3"
                                  class="text-success float-end"
                                  >Paid Off</strong
                                >
                                <strong
                                  v-else-if="pettyCash.status == 4"
                                  class="text-danger float-end"
                                  >Declined</strong
                                >
                              </div>
                            </h6>
                          </b-card-header>
                          <b-collapse
                            :id="'accordion-' + index"
                            accordion="my-accordion"
                            role="tabpanel"
                          >
                            <b-card-body>
                              <b-card-text>
                                <table class="table mt-2">
                                  <thead>
                                    <tr>
                                      <th scope="col">#</th>
                                      <th scope="col">Name</th>
                                      <th scope="col">Amount</th>
                                      <th scope="col">Quantity</th>
                                      <th scope="col">Total</th>
                                      <th scope="col">Narration</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="(pettyItem,
                                      petttyIndex) in pettyCash.petty_items"
                                      :key="petttyIndex"
                                    >
                                      <th scope="row">{{ petttyIndex + 1 }}</th>
                                      <td>{{ pettyItem.name }}</td>
                                      <td>{{ pettyItem.amount }}</td>
                                      <td>{{ pettyItem.quantity }}</td>
                                      <td>
                                        {{
                                          thousandSeperater(
                                            pettyItem.amount *
                                              pettyItem.quantity
                                          )
                                        }}
                                      </td>
                                      <td>
                                        <p>{{ pettyItem.narration }}</p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </b-card-text>
                            </b-card-body>
                          </b-collapse>
                        </b-card>
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
